<app-header></app-header>
<app-banner></app-banner>
<app-card-list></app-card-list>
<app-register-card></app-register-card>
<app-footer></app-footer>
